/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ rfft: NonNullable<unknown> }} Building_Holidays_Settings_Text_4Inputs */

const fr_building_holidays_settings_text_4 = /** @type {((inputs: Building_Holidays_Settings_Text_4Inputs) => LocalizedString) & { parts: (inputs: Building_Holidays_Settings_Text_4Inputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Building_Holidays_Settings_Text_4Inputs) => LocalizedString} */ ((i) => {
			return /** @type {LocalizedString} */ (`En période Hors Gel la température de consigne des x sera:
Consigne de la loi d'eau - ${i?.rfft}°C (Réduit Hors Gel)`)
		}),
		{
			parts: /** @type {(inputs: Building_Holidays_Settings_Text_4Inputs) => import('../runtime.js').MessagePart[]} */ ((i) => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: "En période Hors Gel la température de consigne des x sera:\nConsigne de la loi d'eau - " }, { type: "markup-start", name: "span", options: {}, attributes: {} }, { type: "text", value: String(i?.rfft) }, { type: "text", value: "°C (Réduit Hors Gel)" }, { type: "markup-end", name: "span", options: {}, attributes: {} }])
			})
		}
	)
);

const en_building_holidays_settings_text_4 = /** @type {((inputs: Building_Holidays_Settings_Text_4Inputs) => LocalizedString) & { parts: (inputs: Building_Holidays_Settings_Text_4Inputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Building_Holidays_Settings_Text_4Inputs) => LocalizedString} */ ((i) => {
			return /** @type {LocalizedString} */ (`During frost-free period, the network setpoint temperature will be:
Water law setpoint - ${i?.rfft}°C (Frost-free reduction)`)
		}),
		{
			parts: /** @type {(inputs: Building_Holidays_Settings_Text_4Inputs) => import('../runtime.js').MessagePart[]} */ ((i) => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: "During frost-free period, the network setpoint temperature will be:\nWater law setpoint - " }, { type: "markup-start", name: "span", options: {}, attributes: {} }, { type: "text", value: String(i?.rfft) }, { type: "text", value: "°C (Frost-free reduction)" }, { type: "markup-end", name: "span", options: {}, attributes: {} }])
			})
		}
	)
);

/**
* | output |
* | --- |
* | "During frost-free period, the network setpoint temperature will be: Water law setpoint - {rfft}°C (Frost-free reduction)" |
*
* @param {Building_Holidays_Settings_Text_4Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const building_holidays_settings_text_4 = /** @type {((inputs: Building_Holidays_Settings_Text_4Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & { parts: (inputs: Building_Holidays_Settings_Text_4Inputs, options?: { locale?: "fr" | "en" }) => import('../runtime.js').MessagePart[] } & import('../runtime.js').MessageMetadata<Building_Holidays_Settings_Text_4Inputs, { locale?: "fr" | "en" }, { span: { options: {}; attributes: {}; children: true } }>} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Building_Holidays_Settings_Text_4Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString} */ ((inputs, options = {}) => {
			const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
			if (locale === "en") return en_building_holidays_settings_text_4(inputs)
			return fr_building_holidays_settings_text_4(inputs)
		}),
		{
			parts: /** @type {(inputs: Building_Holidays_Settings_Text_4Inputs, options?: { locale?: "fr" | "en" }) => import('../runtime.js').MessagePart[]} */ ((inputs, options = {}) => {
				const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
				if (locale === "en") return /** @type {{ parts?: (inputs: Building_Holidays_Settings_Text_4Inputs) => import('../runtime.js').MessagePart[] }} */ (en_building_holidays_settings_text_4).parts?.(inputs) ?? [{ type: "text", value: en_building_holidays_settings_text_4(inputs) }]
				return /** @type {{ parts?: (inputs: Building_Holidays_Settings_Text_4Inputs) => import('../runtime.js').MessagePart[] }} */ (fr_building_holidays_settings_text_4).parts?.(inputs) ?? [{ type: "text", value: fr_building_holidays_settings_text_4(inputs) }]
			})
		}
	)
);